<div class="p-4">
    <app-terms></app-terms>
</div>